const exitIntentConfirmation = ({
  message = "Are you sure you want to leave this page without completing your setup?",
  callback
}) => {
  const isConfirmed = window.confirm(message);
  if (!isConfirmed) return null;
  return callback == null ? void 0 : callback();
};
function preventDefaultExitNotification(e) {
  e.preventDefault();
}
const windowExitNotification = () => {
  window.addEventListener("beforeunload", preventDefaultExitNotification);
};
const removeWindowExitNotification = () => {
  window.removeEventListener("beforeunload", preventDefaultExitNotification);
};
export {
  exitIntentConfirmation as e,
  removeWindowExitNotification as r,
  windowExitNotification as w
};
//# sourceMappingURL=exitIntent-D2_P6WHh.js.map
